import {
  IonContent,
  IonHeader,
  IonIcon,
  IonImg,
  IonItem,
  IonLabel,
  IonList,
  IonMenu,
  IonMenuToggle,
  IonToolbar,
} from '@ionic/react';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import { AppPage, appPagesMenu, PATHS } from '../../../navigation/data';
import { selectSelectedCompany, selectSelectedCompanyName } from '../../../store/companies/companiesSlice';
import logo from '../../../theme/assets/logo.webp';
import './Menu.scss';

const Menu: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const company = useSelector(selectSelectedCompany);
  const companyName = useSelector(selectSelectedCompanyName);

  const navigateToCompanies = useCallback(() => {
    navigate(PATHS.COMPANIES);
  }, [navigate]);

  const getLogo = useCallback(() => {
    return (
      <div className="logoContainer">
        <div style={styles.logo}>
          <IonImg src={logo} />
        </div>
      </div>
    );
  }, []);

  const getMenuItem = useCallback(
    (index: number, appPage: AppPage) => {
      return (
        <IonMenuToggle key={appPage.url} autoHide={false}>
          <a
            href={appPage.url}
            onClick={(e) => e.preventDefault()}
            style={{ textDecoration: 'none' }} // Remove underline styling
          >
            <IonItem
              data-testid={`tab_${index}`}
              className={`cursorPointer ion-activatable ${location.pathname === appPage.url ? 'selected' : ''}`}
              onClick={() => navigate(appPage.url)}
              lines="none"
              detail={false}>
              <IonIcon slot="start" ios={appPage.iosIcon} md={appPage.mdIcon} />
              <IonLabel>{t(appPage.title)}</IonLabel>
            </IonItem>
          </a>
        </IonMenuToggle>
      );
    },
    [location.pathname, navigate, t],
  );

  const getMenuItems = useCallback(() => {
    return appPagesMenu.map((appPage, index) => getMenuItem(index, appPage));
  }, [getMenuItem]);

  const getBranchAddress = useCallback(() => {
    if ((company?.branchSerial || 0) > 0 && company?.address) {
      return <div className="boldText3 margin-t-4 truncate-1-lines">{company?.address}</div>;
    }
  }, [company?.address, company?.branchSerial]);

  return (
    <IonMenu contentId="main" type="overlay">
      <IonHeader mode="md">
        <IonToolbar style={{ height: 56 }}>
          <IonMenuToggle autoHide={false}>
            <div className="padding-l-18 cursorPointer" onClick={navigateToCompanies}>
              <div className="mediumText4 truncate-2lines">{companyName}</div>
              {getBranchAddress()}
            </div>
          </IonMenuToggle>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-no-padding">
        <IonList id="inbox-list pad-t-0">{getMenuItems()}</IonList>
        {getLogo()}
      </IonContent>
    </IonMenu>
  );
};

export default Menu;

const styles = {
  logo: {
    width: 200,
    height: 100,
  },
};
